import * as React from 'react';

export function JsonLd({
  data
}: {
  data: Record<string, unknown> | Array<Record<string, unknown>>;
}): React.JSX.Element {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}
